// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__3hBeE","label":"Section_label__9u3a9","contentWrap":"Section_contentWrap__183PD","footer":"Section_footer__sHBRn","footerInner":"Section_footerInner__aST6X"};